import { SITE_MAP } from 'globalConstants';
import {
  FRIEND_REQUEST_LIST,
  FriendRequestListData,
  FriendRequestListVariables,
} from 'graphql/main/queries/temp/friend-request-list';
import { useFlexQuery } from 'hooks';
import { isEmpty, map } from 'lodash';
import Link from 'next/link';
import FriendRequestCard, { FriendRequestCardSkeleton } from './friend-request-card';

const DEFAULT_LIMIT_FRIEND_REQUEST = 2;

const FriendAddingRequestList = () => {
  const { data: friendRequestListData, loading: loadingFriendRequestList } = useFlexQuery<
    FriendRequestListData,
    FriendRequestListVariables
  >('main', FRIEND_REQUEST_LIST, {
    variables: {
      limit: DEFAULT_LIMIT_FRIEND_REQUEST,
    },
  });
  const { friendRequestList: friendPagination } = friendRequestListData ?? {};
  const { data: friendRequestList } = friendPagination ?? {};

  return !isEmpty(friendRequestList) ? (
    <div id='friend-adding-request-list' className='w-[364px] space-y-[16px]'>
      <div className='flex w-full justify-between'>
        <h2 className=' text-[16px] font-[600] leading-[20px] text-text'>Lời mời kết bạn</h2>
        <Link
          href={`/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.FRIEND}`}
          className='text-[12px] font-[600] text-primary'
        >
          Xem tất cả
        </Link>
      </div>
      {loadingFriendRequestList
        ? map(Array(DEFAULT_LIMIT_FRIEND_REQUEST).fill({}), (_, friendRequestSkeletonIndex) => (
            <FriendRequestCardSkeleton key={friendRequestSkeletonIndex} />
          ))
        : map(friendRequestList, (friendRequest, friendRequestIndex) => (
            <FriendRequestCard key={friendRequestIndex} friendRequest={friendRequest} />
          ))}
    </div>
  ) : null;
};

export default FriendAddingRequestList;
